const translation: Record<string, string> = {
    // error view
    e0001: "돌아가기",
    e0002: "403 페이지에 접근할 수 없습니다.",
    e0003: "404 페이지를 찾을 수 없습니다.",
    e0004: "{code} 현재 서비스를 이용할 수 없습니다.",

    // base words
    b0000_ko: "한국어",
    b0000_en: "English",

    b0001: "확인",
    b0002: "취소",
    b0003: "닫기",
    b0004: "업로드",
    b0005: "다운로드",
    b0006: "전체 삭제",
    b0007: "선택 삭제",
    b0008: "삭제",
    b0009: "저장",
    b0010: "등록",
    b0011: "추가",
    b0012: "유효하지 않은 값이 있습니다.",
    b0013: "에러가 발생했습니다.",
    b0014: "검색 결과가 없습니다.",
    b0015: "수정",
    b0016: "성공",
    b0017: "실패",
    b0018: "데이터가 없습니다.",
    b0019: "{version, select, 0 {-} other {v{version}}}",

    // toast words
    t001: "등록을 완료했습니다.",
    t002: "등록 실패",
    t003: "수정을 완료했습니다.",
    t004: "수정 실패",
    t005: "삭제를 완료했습니다.",
    t006: "삭제 실패",
    t007: "삭제할 항목을 선택해주세요",

    // agent sidebar menu name
    m01: "에이전트 목록",
    m02: "대시보드",
    m03: "인텐트",
    m04: "셀렉터",
    m05: "엔티티",
    m06: "유의어",
    m07: "오타교정",
    m08: "자동완성",
    m09: "벌크 테스트",
    m10: "배포",

    m12: "멤버 관리",
    m13: "설정",

    // Component & Layout
    i00001: "에이전트 목록 보기",
    i00002: "작업 진행 현황",
    i00003: "싱글 테스트",
    i00004: "테스트 중 에러가 발생했습니다.",
    i00005: "질의를 입력하세요.",
    i00006: "엔티티",
    i00007: "유의어",
    i00008: "엔티티들",
    i00009: "스킬",
    i00010: "인텐트",
    i00011: "자세히 보기",
    i00012: "전체 응답",
    i00013: "디버그",
    i00014: "user said...",
    i00015: "샘플 파일 받기",
    i00016_1: "이곳에 파일을 놓거나 ",
    i00016_2: "파일을 선택",
    i00016_3: "하세요.",
    i00017: "샘플 파일을 다운받아 업로드 형식에 맞게 작성 후 업로드해주세요.\n" +
        "파일 용량에 제한은 없지만 가급적이면 1만건 단위로 데이터를 입력해주세요.\n" +
        "업로드 파일 형식은 엑셀만 지원됩니다.",
    i00018: "기존의 데이터를 삭제합니다.",
    i00019: "엑셀파일(xls,xlsx)만 첨부하실 수 있습니다.",
    i00020: "파일은 용량은 20MB 이하여야합니다.",
    i00021: "파일 등록에 실패했습니다. 다시 시도하거나 다른 파일을 사용해 주세요.",
    i00022: "업로드 작업을 시작합니다.",
    i00023: "파일 업로드 중 에러가 발생했습니다.",
    i00024: "{total}개 중 {current}",
    i00025: "페이지",
    i00026: "날짜",
    i00027: "작업 진행 현황",
    i00028: "에이전트",
    i00029: "인텐트",
    i00030: "오타교정",
    i00031: "엔티티 업로드",
    i00032: "유의어",
    i00033: "셀렉터",
    i00034: "자동완성",
    i00035: "대량 테스트",
    i00036: "Sandbox 학습",
    i00037: "서비스 반영",
    i00038: "엔티티 다운로드",
    i00039: "엔티티 삭제",
    i00040: "벌크 엔티티 삽입",
    i00041: "벌크 엔티티 적용",
    i00042: "진행중",
    i00043: "대기중",
    i00044: "취소됨",
    i00045: "오류",
    i00046: "완료됨",
    i00047: "작업",
    i00048: "진행도",
    i00049: "시작시간",
    i00050: "진행 시간",
    i00051: "남은 시간",
    i00052: "처리 시간",
    i00053: "링크",
    i00054: "상태",
    i00055: "개인정보 설정",
    i00056: "비밀번호 변경",
    i00057: "언어",
    i00058: "로그아웃",
    i00059: "관리자",
    i00060: "멤버",
    i00061: "{job} 작업이 완료되었습니다.",
    i00062: "{job} 작업 중 에러가 발생했습니다.",
    i00063: "자동완성 삭제",
    i00064: "{max}일 이내로 조회해 주세요.",
    i00065: "다운",
    i00066: "개 선택됨",
    i00067: "모두선택",
    i00068: "선택해제",
    i00069: "이동",
    i00070: "검색어를 입력하세요.",
    i00071: "필수 입력값입니다.",
    i00072: "죄송합니다. 현재는 파악할 수 없는 의도입니다.",
    i00073: "파일을 업로드해주세요",
    i00074: "미래의 날짜는 선택할 수 없습니다.",
    i00075: "날짜 형식이 올바르지 않습니다. yyyy.mm.dd 형식으로 입력해주세요.",


    // Agent List
    i01001: "에이전트 추가",
    i01002: "에이전트명",
    i01003: "에이전트명을 입력하세요.",
    i01004: "언어",
    i01005: "의도분류 모델 설정",
    i01005_o1: "기본값",
    i01005_o2: "OpenAI Ada(Experimental)",
    i01006: "디파인더 임계치",
    i01007: "디파인더 결과 개수",

    i01011: "에이전트명 또는 소유자 이름으로 검색하세요.",
    i01012: "활성화",
    i01013: "비활성화",
    i01014: "사용 중인 에이전트가 없습니다.\n'에이전트 추가'를 클릭 한 후 에이전트를 만들어 주세요.",
    i01015: "소유자",
    i01016: "비활성화 에이전트",
    i01017: "해당 에이전트는 비활성화된 에이전트입니다. 다시 활성화하시겠습니까?",
    i01018: "등록실패. 이미 사용중인 에이전트명 입니다.",
    i01019: "에이전트",
    i01020: "변경일시",
    i01021: "생성일시",

    //Dashboard
    i02001: "에이전트 현황을 안내합니다.",
    i02002: "에이전트 현황",
    i02003: "인텐트",
    i02004: "엔티티",
    i02005: "버전",
    i02006: "(개)",

    i02008: "인텐트 랭킹",
    i02009: "유입 쿼리 수",
    i02010: "유입건수",
    i02011: "표로 보기",
    i02012: "유입일시",
    i02013: "스킬",
    i02014: "인텐트",
    i02015: "유입문장",
    i02016: "데이터가 없습니다.",
    i02017: "에이전트 통계",
    i02018: "로그",
    i02019: "쿼리 수",
    i02020: "YYYY년 MM월 DD일",
    i02021: "점수",
    i02022: "인텐트",
    i02023: "학습문장",
    i02024: "학습 버전",
    i02025: "배포 버전",
    i02026: "엔티티",
    i02027: "엔티티 값",
    i02028: "미분류",

    //Intent
    i03001: "인텐트 분류에 필요한 학습문장을 관리합니다.",
    i03002: "인텐트 업로드",
    i03003: "학습데이터를 입력해 주세요. 예시) 피자 주문하고 싶어요",
    i03004: "intent 명을 입력해 주세요. 예시) 피자주문",
    i03005: "selectedSkill 명을 입력해 주세요. 예시) 주문",
    i03006: "스킬 및 인텐트 전체 삭제",
    i03007: "스킬 및 인텐트 하위의 학습문장까지 모두 삭제됩니다.",

    i03009: "스킬 추가",
    i03010: "스킬명을 입력하세요.",
    i03011: "스킬 수정",
    i03012: "스킬 삭제",
    i03013: "스킬을 삭제합니다. 스킬 하위의 인텐트 및 학습문장도 삭제됩니다.",

    i03020: "스킬",
    i03021: "인텐트 추가",
    i03022: "인텐트명을 입력하세요.",
    i03023: "인텐트 설정",
    i03024: "인텐트명 수정",
    i03025: "인텐트 활성화",
    i03026: "인텐트 임계치 ({threshold})",
    i03027: "인텐트 답변",
    i03028: "인텐트 답변은 최대 5개까지 작성 가능하며 랜덤하게 노출됩니다.",
    i03029: "인텐트 삭제",
    i03030: "인텐트를 삭제합니다. 인텐트 하위의 학습문장도 삭제됩니다.",
    i03031: "슬롯 설정",
    i03032: "File_name, Title , Description 은 매핑 필수 컬럼입니다.",
    i03033: "{intentName} 슬롯",
    i03034: "삭제",
    i03035: "필수",
    i03036: "목록",
    i03037: "파라미터",
    i03038: "파라미터를 입력하세요.",
    i03039: "엔티티",
    i03040: "엔티티를 입력하세요.",
    i03041: "엔티티 값",
    i03042: "키워드",
    i03043: "기본값",
    i03044: "기본값을 입력하세요.",
    i03045: "슬롯 설정 안내",
    i03046: "슬롯 채우기 과정을 통해 고객에게 분석결과를 전달하세요.",
    i03047: "인텐트 이름을 클릭하시면 인텐트로 학습된 데이터를 확인할 수 있습니다.",
    i03048: "데이터별 특성을 확인해 슬롯 설정을 해주세요.",

    i03050: "학습문장 답변",
    i03051: "학습문장 답변은 최대 5개까지 작성 가능하며 랜덤하게 노출 됩니다.",
    i03052: "학습문장 삭제",
    i03053: "학습문장을 삭제합니다.",
    i03054: "학습문장을 입력하세요.",
    i03055: "인텐트",

    i03061: "학습문장 펴기",
    i03062: "학습문장 접기",
    i03063: "Keyword",
    i03064: "Synonym",
    i03065: "Mapping Value",
    i03066: "Nothing",
    i03067: "인텐트 이동",
    i03068: "이동할 스킬을 선택하세요.",
    i03069: "인텐트",
    i03070: "학습문장",
    i03071: "등록된 모든 인텐트를 삭제합니다.",
    i03072: "Enter a sentence",

    //Selector
    i04001: "등록 문장과 일치하는 경우에만 해당 인텐트로 분류합니다.",
    i04002: "셀렉터 업로드",
    i04003: "특정 인텐트(intent name)으로 분류할 문장을 입력하세요. 예시) 피자 먹자.",
    i04004: "text에 해당하는 intent명을 입력하세요. 예시) 피자주문",
    i04005: "셀렉터",
    i04006: "문장을 입력하세요",
    i04007: "문장을 입력해주세요.",
    i04008: "인텐트",
    i04009: "인텐트를 선택하거나 입력하세요",
    i04010: "인텐트를 선택하거나 입력해주세요.",

    i04013: "셀렉터 선택 삭제",
    i04014: "셀렉터를 삭제합니다.",
    i04015: "셀렉터 또는 인텐트로 검색하세요.",
    i04016: "셀렉터",
    i04017: "인텐트",
    i04018: "셀렉터 수정",
    i04019: "셀렉터 삭제",

    i04022: "셀렉터를 삭제합니다.",
    i04023: "등록된 모든 셀렉터를 삭제합니다.",

    //Entity
    i05001: "의도분류에 사용할 사전을 등록 관리합니다.",
    i05002: "엔티티",
    i05003: "타입",

    i05005: "엔티티 추가",
    i05006: "엔티티 명",
    i05007: "옵션",

    i05009: "엔티티명을 입력하세요.",
    i05012: "엔티티 수정",
    i05013: "엔티티 삭제",
    i05014: "엔티티를 삭제합니다.",
    i05015: "entity name(개체명)을 입력하세요. 예시) 핸드폰이름",
    i05016: "키워드를 입력하세요. 예시) 아이폰",
    i05017: "키워드의 유의어를 입력하세요 예시) 사과폰",
    i05018: "(필수아님) 키워드를 대체할 value를 입력하세요. 예시) code=1",
    i05019: "(필수아님) Ignore Entity로 등록하시려면 1이나 True라고 입력하세요",
    i05020: "(필수아님) Post Entity로 등록하시려면 1이나 True라고 입력하세요",
    i05021: "엔티티 업로드",
    i05022: "엔티티 선택 삭제",
    i05023: "엔티티를 삭제합니다.",
    i05024: "엔티티 목록",
    i05025: "엔티티명으로 검색하세요.",
    i05026: "엔티티 목록 보기",
    i05027: "키워드",
    i05028: "키워드를 입력하세요.",
    i05029: "매핑 값",
    i05030: "매핑 값을 입력하세요. (선택)",
    i05031: "유의어",
    i05032: "유의어를 입력하세요.",

    i05034: "키워드",
    i05035: "유의어",
    i05036: "매핑 값",
    i05037: "엔티티 값 수정",
    i05038: "엔티티 값 삭제",
    i05039: "엔티티 값 선택 삭제",
    i05040: "선택한 엔티티 값을 삭제하시겠습니까?",
    i05041: "엔티티 값 삭제",
    i05042: "엔티티 값을 삭제합니다.",
    i05043: "NORMAL ENTITY는 의도 분류에 영향을 주는 사전입니다.",
    i05044: "POST ENTITY는 의도 분류에 영향을 주지 않고 분석만 진행합니다.",
    i05045: "IGNORE ENTITY는 사용자 질의 중 해당 엔티티 값을 공백으로 처리합니다.",
    i05046: "키워드를 입력해주세요.",
    i05047: "유의어를 추가해주세요.",
    i05048: "등록된 모든 엔티티를 삭제합니다.",
    i05049: "엔티티 값",
    i05050: "엔티티",
    i05051: "목록으로",

    //Synonym
    i06001: "엔티티 사전으로 관리할 필요는 없지만 유의어 처리가 필요한 단어를 관리합니다.",
    i06002: "유의어 수정",
    i06003: "유의어 삭제",
    i06004: "유의어 선택 삭제",
    i06005: "유의어를 삭제합니다.",

    i06007: "유의어 업로드",
    i06008: "대표 키워드를 입력하세요.  예시) 해를 품은 달",
    i06009: "keyword의 유의어를 입력하세요. 예시) 해품달",
    i06010: "대표 키워드",
    i06011: "대표 키워드를 입력하세요.",
    i06012: "대표 키워드를 입력해주세요.",
    i06013: "유의어를 입력하세요.",
    i06014: "유의어",
    i06015: "유의어를 추가해주세요.",
    i06016: "대표 키워드 또는 유의어로 검색하세요.",
    i06017: "대표 키워드",
    i06018: "등록된 모든 유의어를 삭제합니다.",

    //Typo
    i07001: "사전 기반으로 오타를 교정합니다.",
    i07002: "교정 키워드",
    i07003: "오타 키워드",
    i07004: "교정 키워드를 입력하세요.",
    i07005: "교정할 키워드를 입력해주세요.",
    i07006: "오타를 입력하세요.",
    i07007: "오타를 추가해주세요.",
    i07008: "교정 키워드 또는 오타 키워드로 검색하세요.",
    i07009: "오타교정 수정",
    i07010: "오타교정 삭제",
    i07011: "교정 키워드",
    i07012: "오타교정 업로드",
    i07013: "오타교정 선택 삭제",
    i07014: "오타교정을 삭제합니다.",
    i07016: "오타교정을 삭제합니다.",
    i07017: "오타를 교정할 키워드를 입력하세요  예시) 딥러닝",
    i07018: "키워드에 해당하는 오타를 입력하세요. 예시) 디ㅂ러닝",
    i07019: "등록된 모든 오타교정을 삭제합니다.",

    //Autocomplete
    i08001: "웹챗의 입력창에 사용할 자동완성을 등록 관리합니다.",
    i08002: "자동완성",

    i08004: "자동완성 수정",
    i08005: "자동완성 삭제",
    i08006: "자동완성 추가",
    i08007: "자동완성 제목을 입력하세요.",
    i08008: "자동완성 선택 삭제",
    i08009: "자동완성을 삭제합니다.",
    i08010: "자동완성 수정",
    i08011: "자동완성 명",
    i08012: "자동완성 토큰",
    i08013: "• 토큰은 수정되면 재배포가 필요합니다.",
    i08014: "자동완성을 삭제합니다.",
    i08015: "자동완성 제목을 입력하세요.",
    i08016: "자동완성 토큰을 입력하세요.",
    i08017: "자동완성 제목",
    i08018: "토큰",
    i08019: "제목 및 토큰은 다른 자동완성 목록과 겹칠 수 없습니다. 시나리오에 사용 중인 자동완성의 토큰을 바꿀 경우 재베포를 해야합니다.",

    i08021: "자동완성에 사용할 문장을 입력하세요.",
    i08022: "고객이 질문을 입력할 때 보여질 추천 문장을 입력하세요. 예시) 피자 주문할께요.",
    i08023: "자동완성 업로드",
    i08024: "자동완성 문장 수정",
    i08025: "자동완성 문장 삭제",
    i08026: "자동완성 문장을 삭제합니다.",
    i08027: "선택한 자동완성 문장을 삭제하시겠습니까?",
    i08028: "자동완성 문장 선택 삭제",
    i08029: "자동완성 테스트",
    i08030: "키워드",
    i08031: "목록으로",
    i08032: "등록된 모든 자동완성 문장을 삭제합니다.",
    i08033: "자동완성 문장",
    i08034: "자동완성",

    //Bulk Test
    i09001: "대량 테스트를 통해 인텐트의 정확도를 체크하세요.",
    i09002: "테스트 등록",
    i09003: "테스트명",
    i09004: "테스트명으로 검색하세요.",
    i09005: "테스트 파일명",
    i09006: "테스트 파일명으로 검색해주세요.",
    i09007: "버전",
    i09008: "테스트 일시",
    i09009: "결과",
    i09010: "상태",
    i09011: "완료",
    i09012: "진행중",
    i09013: "취소",
    i09014: "실패",
    i09015: "테스트할 문장을 입력하세요. 예시) 피자 주문하고 싶어요",
    i09016: "query가 분류될 intent 명을 입력하세요. 예시) 피자주문",
    i09017: "intent명의 skill명을 입력하세요. 예시) 주문",
    i09018: "정답율",
    // i09019: "테스트 결과",
    i09020: "테스트 버젼: ",
    // i09021: "테스트 쿼리:",
    // i09022: "입계점에 다른 정답율 ({score}점)",
    i09023: "성공",
    i09024: "실패",
    i09025: "테스트 쿼리",
    // i09026: "테스트 전체 결과",
    i09027: "질문",
    // i09028: "테스트 인텐트 및 문장으로 검색해주세요.",
    i09029: "인텐트 기대값",
    i09030: "인텐트명으로 검색해주세요.",
    i09031: "인텐트 결과값",
    i09032: "인텐트명으로 검색해주세요.",
    i09033: "결과",
    // i09034: "전체",
    i09035: "성공",
    i09036: "실패",
    i09037: "점수",
    i09038: "취소",
    i09039: "테스트명을 입력하세요.",
    i09040: "파일명:",
    i09041: "테스터:",
    i09042: "날짜:",
    i09043: "임계점:",
    i09043_1: "{score}점",
    i09044: "목록으로",
    i09045: "벌크테스트는 학습버전에서 진행됩니다.",
    i09046: "테스트 삭제",
    i09047: "테스트를 삭제합니다.",
    i09048: "테스트 선택 삭제",
    i09049: "테스트 파일 업로드",

    //Deployment
    i10001: "새로 학습한 학습문장, 엔티티 사전 등을 서비스에 배포합니다.",
    i10002: "학습",
    i10003: "배포",
    i10004: "배포 안내",
    
    i10007: "현재 상태의 데이터를 학습합니다.",
    i10008: "학습 버전의 데이터를 서비스에 반영하시겠습니까?",
    
    i10013: "구분",
    i10014: "학습 버전",
    i10015: "배포 버전",
    
    i10027: "버전",
    i10028: "작업 일시",
    i10029: "작업자",
    i10030: "에이전트 업로드",
    i10031: "작업 내용",
    i10032: "서비스 중",
    i10033: "학습 기록이 없습니다.",
    i10034: "작업 내용",
    i10035: "작업 내용을 입력해주세요.",
    i10036: "배포 시간:",
    i10037: "배포 담당자:",
    i10038: "등록된 모든 학습문장, 엔티티 등을 삭제합니다.",

    //Statistics

    //Member
    i12001: "NLU를 사용하는 멤버를 관리합니다.",
    i12002: "멤버 추가",

    i12004: "이름",
    i12005: "아이디(이메일)",
    i12006: "소속",
    i12007: "유형",
    i12008: "변경 일시",
    i12009: "마지막 로그인",
    i12010: "초대할 사용자의 이메일을 검색하세요.",
    i12011: "변경할 소유자의 이메일을 검색하세요.",
    i12012: "Chat42 멤버 등록 안내",
    i12013: "{username}님을 멤버로 등록했습니다.",
    i12014: "에이전트로 이동하기",
    i12015: "멤버 정보 수정",
    i12016: "아이디",
    i12017: "권한",
    i12018: "멤버 삭제",
    i12019: "삭제한 멤버는 에이전트 사용이 불가능합니다.",
    i12020: "멤버 수정",
    i12021: "아이디 또는 이름으로 검색하세요.",
    i12022: "소유자",
    i12023: "멤버",
    i12024: "계정 유형",
    i12025: "유효한 이메일 주소를 입력해주세요.",
    i12026: "소속을 입력해주세요",
    i12027: "소유자 변경",
    i12028: "에이전트 소유자를 {username} 님으로 변경합니다.",
    i12029: "멤버 추가",
    i12030: "이메일",
    i12031: "이름",
    i12032: "소속",
    i12033: "소속을 입력해주세요.",

    //Setting
    i13001: "에이전트 설정을 변경 할 수 있습니다.",
    i13002: "에이전트명",
    i13003: "에이전트 토큰",

    i13005: "시스템 엔티티 설정",
    i13006: "구분",
    i13007: "사용",
    i13008: "후처리",
    i13009: "시간",
    i13010: "날짜",
    i13011: "화폐",
    i13012: "단위",
    i13013: "전화번호",
    i13014: "숫자",
    i13015: "수량",
    i13016: "에이전트 임계치",
    i13017: "에이전트 삭제",

    i13019: "시,분,초 형식으로 인식",
    i13019_1: "ex) 12시30분25초, 오후 3시 15분",
    i13020: "년, 월, 일 형식으로 날짜 인식",
    i13020_1: "ex) 2022년 08월 17일, 2022-08-17, 2022-08-17",
    i13021: "원, ₩, KRW, krw로 끝나는 숫자데이터 화폐로 인식, 한글발음 숫자 표기법 인식",
    i13021_1: "ex) 3000원, 삼십삼만원",
    i13022: "cm, mm, m 형식 인식, 한글표기법 인식",
    i13022_1: "ex) 260mm, 260밀리미터, 2미터30센치",
    i13023: "일반적 전화번호 표기방식 인식",
    i13023_1: "ex) 0101-1234-1234, 010-1234-1234",
    i13024: "숫자 형식 모두 인식, 한글 발음 표기 숫자 인식",
    i13024_1: "ex) 123, 삼십삼억",
    i13025: "주,개 형식 주식 수량으로 인식",
    i13025_1: "ex) 100주, 100개",
    i13026: "시스템 엔티티 안내",
    i13027: "인텐트 결과 노출 수",

    i13029: "에이전트를 삭제하면 되돌릴 수 없습니다.\n신중하게 생각하고 결정하세요.\n삭제 하시겠습니까?",

    i13031: "토큰을 복사했습니다.",
    i13032: "에이전트 토큰 갱신",
    i13033: "에이전트 토큰을 재발급 합니다.",
    i13034: "토큰 재발급 후 에이전트를 이용하는 클라이언트의 토큰도 동일하게 변경해야 합니다.",

};

export default translation;
